import { Component, OnInit, Input } from '@angular/core';
import { IProvenance } from '@ahryman40k/ts-fhir-types/lib/R4';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'inc-device-status-table',
  templateUrl: './device-status-table.component.html',
  styleUrls: ['./device-status-table.component.scss'],
})
export class DeviceStatusTableComponent implements OnInit {
  @Input() list: MatTableDataSource<IProvenance>;
  displayedColumns = ['newStatus', 'comment', 'responsible', 'owning', 'date'];

  constructor() { }

  ngOnInit() {
  }

}
